export default __webpack_public_path__ + "static/media/coin_ada.fc417c10.svg";